import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';

function CircleArrowButton({ onClick, className = '', ariaLabel }) {
  const { t } = useTranslation();
  return (
    <button
      className={`circle-arrow-button ${className}`}
      onClick={onClick}
      aria-label={ariaLabel || t('common.ariaViewDetail')}
    >
      <span className="circle-arrow-icon" style={{ backgroundImage: 'url(/image/白箭头.png)' }}></span>
    </button>
  );
}

export default CircleArrowButton;
